function getReferrerFromCookie() {
    let name = "referrerbanner=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

const referSearchParams = new URLSearchParams(window.location.search);
const referBannerParam = referSearchParams.get('referrerbanner') ?? getReferrerFromCookie();

function getReferrer() {
    switch (referBannerParam) {
        case 'bristol-airport':
            return {
                color: "#FFFFFF",
                textColor: "#002251",
                logo: "bristol-logo.png"
            }
        case 'simgularity':
            return {
                color: "#FFFFFF",
                textColor: "#000000",
                logo: "simgularity-logo.png"
            }
        case 'interchange':
            return {
                color: "#E66313",
                textColor: "#FFFFFF",
                logo: "interchange-logo.jpg"
            }
        case 'cacao':
            return {
                color: "#FFFFFF",
                textColor: "#351500",
                logo: "cacao-logo.png"
            }
        case 'wetravel':
            return {
                color: "#FFFFFF",
                textColor: "#19BED3",
                logo: "wetravel-logo.png"
            }
        case 'easivacay':
            return {
                color: "#FFFFFF",
                textColor: "#000000",
                logo: "easivacay-logo.png"
            }
        case 'holidayextras':
            return {
                color: "#512888",
                textColor: "#FFFFFF",
                logo: "holidayextras-logo.png"
            }
        case 'visafirst':
            return {
                color: "#FFFFFF",
                textColor: "#000000",
                logo: "visafirst-logo.png"
            }
        case 'getbybus':
            return {
                color: "#eef2fb",
                textColor: "#000000",
                logo: "getbybus-logo.png"
            }
        case 'goabroad':
            return {
                color: "#FFFFFF",
                textColor: "#000000",
                logo: "goabroad-logo.png"
            }
        case 'evisaexpress':
            return {
                color: "#FFFFFF",
                textColor: "#000000",
                logo: "evisaexpress-logo.png"
            }
        case 'ripple':
            return {
                color: "#FFFFFF",
                textColor: "#000000",
                logo: "ripple-logo.png"
            }
        case 'formulaescapes':
            return {
                color: "#A52624",
                textColor: "#FFFFFF",
                logo: "formulaescapes-logo.png"
            }
        case 'africarally':
            return {
                color: "#000000",
                textColor: "#FFFFFF",
                logo: "africarally-logo.png"
            }
        case 'tagalongtravels':
            return {
                color: "#2A2A2A",
                textColor: "#FFFFFF",
                logo: "tagalongtravels-logo.png"
            }
        case 'amdocs':
            return {
                color: "#FFFFFF",
                textColor: "#000000",
                logo: "amdocs-logo.png",
                link: "https://www.amdocs.com/?utm_source=breezesim&utm_medium=referral&utm_campaign=pmm_q3_fy24_se_esim_eurovision"
            }
        case "esimmada":
            return {
                color: "#1C82B3",
                textColor: "#FFFFFF",
                logo: "esimmada-logo.png",
            };
        case "sourcetravel":
            return {
                color: "#FFFFFF",
                textColor: "#000000",
                logo: "sourcetravel-logo.png",
            };
        case "aps":
            return {
                color: "#FFFFFF",
                textColor: "#000000",
                logo: "aps-affiliate-logo.png",
            }; 
        case "trinqoo":
            return {
                color: "#FFFFFF",
                textColor: "#40A5D2",
                logo: "trinqoo-affiliate-logo.png",
                }; 
        case "confused":
            return {
                color: "#000",
                textColor: "#FFF",
                logo: "confused_logo.png",
                extra_info: "referrer_extra_info_1",
                extra_style: "@media screen and (max-width:670px){.announcement-bar span, img {font-size: 12px !important; padding: 0 !important; justify-self: center;} .announcement-bar p {display:grid !important;} .announcement-bar img {margin: -5px 0 !important;}}"
                };                          
        case "esim-co-il":
            return {
                color: "#FFF",
                textColor: "#ea0808",
                extra_info: "referrer_extra_info_2",
                extra_style: ".announcement-bar__message > span:nth-child(1), .announcement-bar__message > img{ display:none } .announcement-bar__link {text-decoration: none; }",
                link: "https://esim.co.il/"
                };  
        case "vsd":
            return {
                color: "#FFFFFF",
                textColor: "#000",
                logo: "vsd-logo.png",
                };                         
        case "traveo":
            return {
                color: "#FFFFFF",
                textColor: "#000",
                logo: "traveo-logo.png",
                };   
        case "perksmobile":
            return {
                color: "#FFFFFF",
                textColor: "#073766",
                logo: "perks-mobile-logo.png",
                };      
        case "abreu":
            return {
                color: "#FFFFFF",
                textColor: "#0360ae",
                logo: "abreu-logo.png",
                link: "https://www.abreu.pt/"
                };                      
        case "bestravel":
            return {
                color: "#FFF",
                textColor: "#000",
                logo: "bestravel.png",
                link: "https://bestravel.pt/",
                };
        case "gea":
            return {
                color: "#0f1377",
                textColor: "#FFF",
                logo: "GEA.png",
                link: "https://geaportugal.com/"
                };                       
        case "capitalclub":
            return {
                color: "#000",
                textColor: "#FFF",
                logo: "capital-club.gif",
                link: "https://www.capital.club/"
                };                       
        case "swisseducationgroup":
            return {
                color: "#FFF",
                textColor: "#000",
                logo: "SEG.png",
                link: "https://www.swisseducation.com/"
                };                       
        case "clicknpay":
            return {
                color: "#07a1a2",
                textColor: "#000",
                logo: "clicknpay.png",
                extra_style: ".announcement-bar span {display:none} .announcement-bar img {max-width:400px}"
                };
        case "nadapay":
            return {
                color: "#000",
                textColor: "#fff",
                logo: "nadapay-logo.png"
                };       
        case "bookingforbusiness":
            return {
                color: "#003B95",
                textColor: "#fff",
                logo: "bookingforbusiness.jpg",
                extra_style: "@media screen and (max-width:762px){.announcement-bar span, img {font-size: 12px !important; padding: 0 !important; justify-self: center;} .announcement-bar p {display:grid !important;} .announcement-bar img {margin: 5px 0 !important;}} .announcement-bar img {max-height: 30px !important;}"
                };
        case "comfortpass":
            return {
                color: "#fff",
                textColor: "#000",
                logo: "comfortpass_logo.jpg"
                };       
        case "mobox":
            return {
                color: "#1c1c1c",
                textColor: "#fff",
                logo: "mobox-logo.png"
                };
        case "bookingcom":
            return {
                color: "#003B95",
                textColor: "#fff",
                link: "https://www.booking.com/",
                extra_style: ".announcement-bar img{display:none}.announcement-bar p{justify-content: start !important}.announcement-bar span:first-child{display: none !important}.announcement-bar span{font-weight: 100}.announcement-bar__link{padding: 2rem 0}.announcement-bar{position: fixed !important;bottom: 0;left:0;right:0;} .footer{padding-bottom:80px !important;}",
                extra_info: "< Back to <strong>Booking.com</strong>"
                };       
        case "randomwalkr":
            return {
                color: "#fff",
                textColor: "#000",
                logo: "random-walkr-logo.png",
                extra_style: ".announcement-bar img{max-height:36px!important}"
                };     
        case "badasstours":
            return {
                color: "#38303C",
                textColor: "#D6D5D7",
                logo: "badass_tours.png"
                };
        case "seatboost":
            return {
                color: "#091f3b",
                textColor: "#fff",
                logo: "SeatBoost.png"
                };
        case "educationfirst":
            return {
                color: "#fff",
                textColor: "#000",
                logo: "EF-Logos_EF.png"
                };
        case "flylooper":
            return {
                color: "#01AEDD",
                textColor: "#FFF",
                logo: "flylooper_logo.png"
                };
        default:
            return null;
    }
}

if (referBannerParam) {
    let referrer = getReferrer();
    let extraInfo = referrer.extra_info ?? '';

    if (referrer) {
        let referralLogo = referralInfo.referrer_file.replace('referrer_logo', referrer.logo);

        let bannerContent = `
                <p class="announcement-bar__message h5" style="font-size: calc(var(--font-heading-scale) * 1.8rem); text-align: center; display: flex; align-items: center; justify-content: center;">
                    <span style="color: ${referrer.textColor}">${referralInfo.referrer_text}</span>
                    <img src="${referralLogo}" style="max-height: 48px; padding-left: 10px;" alt="${referBannerParam}">
                    <span style="padding-left:8px; color: ${referrer.textColor}">${referralInfo[extraInfo] ?? ''}</span>
                </p>`;

        if (referrer.link){
            bannerContent = `<a class="announcement-bar__link" href="${referrer.link}" target="_blank">` + bannerContent + `</a>`
        }

        let announcementBarHtml =
            `<div class="announcement-bar" style="background: ${referrer.color}" role="region" aria-label="${referralInfo.referrerText} ${referBannerParam}">
                <div class="page-width"> 
                    <style type="text/css">` + referrer.extra_style + `</style>
                    `+bannerContent+`
                </div>
            </div>`;

        document.querySelector('.announcement-bar-section').innerHTML = announcementBarHtml;
    }
}
